import { makeStyles } from '@mui/styles'
import TopBG from '../../assets/images/core/option_bg.png'

export const swchstyle = (xsm) => {
    let s = makeStyles(theme => ({
        btnHover: {
            '&:hover': {
                backgroundColor: '#EDEDED',
            },
        },
        button: {
            textTransform: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            boxShadow: '0 0.1rem 0.3rem rgba(0, 0, 0, .15)'
        },
        tf: {
            fontSize: '10px',
            '& label.Mui-focused': {
                color: theme.palette.primary.business
            },
            '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                    borderColor: theme.palette.primary.business
                },
            }
        },
        bgpalette: {
            backgroundColor: theme.palette.primary.business
        },
        top_bg: {
            backgroundPosition: 'top', 
            backgroundSize: '100%',
            backgroundColor: '#ffffff',
            backgroundImage: `url(${TopBG})`,
            backgroundRepeat: 'no-repeat',
            // width: '47%',
            // height: '500px'
        },
        opt1:{
            textTransform:'none',
            height:xsm ? '51px':'70px',
            backgroundColor:'#FFFFFF',
            padding:xsm ? '8px 12px 8px 12px':'12px 16px 12px 16px',
            textAlign:'left',
            display:'flex',
            justifyContent:'flex-start',
            color:'#283745',
            boxShadow:'0px 2px 4px 0px #28374514, 0px 0px 6px 0px #28374505',
            '&:hover': {
                backgroundColor: '#F5F5F5',
            },
        },
        opt2:{
            textTransform:'none',
            height:xsm ? '36px':'52px',
            backgroundColor:'#FFFFFF',
            padding:xsm ? '8px 12px 8px 12px': '16px',
            textAlign:'left',
            display:'flex',
            justifyContent:'flex-start',
            color:'#283745',
            boxShadow:'0px 2px 4px 0px #28374514, 0px 0px 6px 0px #28374505',
            '&:hover': {
                backgroundColor: '#F5F5F5',
            },
        },
        opt3:{
            textTransform:'none',
            height:xsm ? '36px': '40px',
            backgroundColor:'#FFFFFF',
            padding:'12px 0px 12px 0px',
            color:'#283745',
            boxShadow:'0px 2px 4px 0px #28374514, 0px 0px 6px 0px #28374505',
            '&:hover': {
                backgroundColor: '#F5F5F5',
            },
        },
    }));

    return s()
}

export const LogoAnimator = () => {
    const loaderContainer = {
        start: {
            transition: {
                staggerChildren: 0.2,
            },
        },
        end: {
            transition: {
                staggerChildren: 0.2,
            },
        },
    }
    
    const cVariants = {
        start: {
            y: '0%',
            rotate: '-9deg'
            // opacity: 0,
            // scale: 1
        },
        end: {
            y: [`-12%`, '12%'],
            rotate: '9deg'
            // opacity: 1,
            // scale: 1.5,
        },
    }

    const cVariants1 = {
        start: {
            y: '0%',
            rotate: '-15deg'
            // opacity: 0,
            // scale: 1
        },
        end: {
            y: [`-12%`, '12%'],
            rotate: '-9deg'
            // opacity: 1,
            // scale: 1.5,
        },
    }

    const cVariants2 = {
        start: {
            y: '0%',
            rotate: '15deg'
            // opacity: 0,
            // scale: 1
        },
        end: {
            y: [`-12%`, '12%'],
            rotate: '9deg'
            // opacity: 1,
            // scale: 1.5,
        },
    }
    
    const cTransition = {
        duration: 1.5,
        repeat: Infinity,
        repeatType: 'reverse',
        ease: 'easeInOut',
    }

    return {loaderContainer, cVariants, cVariants1, cVariants2, cTransition}
}